class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerHeight = 0;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.extraSpace = 20;
    this.lastScroll = 0;
    this.onScroll = this.handleScroll.bind(this);
    this.onMobileMatch = this.handleSticky.bind(this);
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", this.onMobileMatch);
    document.addEventListener("unmatchMobile", this.onMobileMatch);
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    document.removeEventListener("matchMobile", this.onMobileMatch);
    document.removeEventListener("unmatchMobile", this.onMobileMatch);
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += Math.round(section.getBoundingClientRect().height);
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += Math.round(topBar.getBoundingClientRect().height);

    this.extraSpace = extraSpace;
    this.headerHeight = this.domNodes.headerWrapper ? Math.round(this.domNodes.headerWrapper.getBoundingClientRect().height) : 0;
    this.lastScroll = window.scrollY;

    window.removeEventListener("scroll", this.onScroll);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.handleScroll();
  }

  handleScroll() {
    const currentScroll = window.scrollY;
    if (currentScroll <= this.extraSpace) {
      this.classList.remove(this.classes.scrollUp, this.classes.scrollDown, this.classes.stuck, this.classes.always);
      document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
      this.lastScroll = currentScroll;
      return;
    }

    if (this.stickyHeader === "on_scroll_up") {
      this.classList.add(this.classes.stuck);
    } else if (this.stickyHeader === "always") {
      this.classList.add(this.classes.always);
    }

    if (
      currentScroll > this.headerHeight + this.extraSpace &&
      currentScroll > this.lastScroll &&
      !this.classList.contains(this.classes.scrollDown)
    ) {
      this.classList.remove(this.classes.scrollUp);
      document.body.classList.remove(this.classes.headerScrollUp);
      this.classList.add(this.classes.scrollDown);
      document.body.classList.add(this.classes.headerScrollDown);
    } else if (currentScroll < this.lastScroll && this.classList.contains(this.classes.scrollDown)) {
      this.classList.remove(this.classes.scrollDown);
      document.body.classList.remove(this.classes.headerScrollDown);
      this.classList.add(this.classes.scrollUp);
      document.body.classList.add(this.classes.headerScrollUp);
    }
    this.lastScroll = currentScroll;
  }
}
customElements.define("m-header", MHeader);
